//#region src/foundations/motion/motion-tokens.ts
var e = {
	instant: 100,
	fast: 150,
	base: 200,
	slow: 300,
	deliberate: 500
}, t = {
	out: "cubic-bezier(0.23, 1, 0.32, 1)",
	"in-out": "cubic-bezier(0.77, 0, 0.175, 1)",
	standard: "ease"
}, n = {
	snappy: {
		type: "spring",
		visualDuration: .2,
		duration: .2,
		bounce: 0
	},
	smooth: {
		type: "spring",
		visualDuration: .3,
		duration: .3,
		bounce: 0
	},
	release: {
		type: "spring",
		visualDuration: .3,
		duration: .3,
		bounce: .15
	},
	expressive: {
		type: "spring",
		visualDuration: .4,
		duration: .4,
		bounce: .25
	}
}, r = {
	pressScale: .97,
	smallPressScale: .96,
	enterScale: .96,
	exitScale: .98,
	anchoredOffset: 4,
	overlayOffset: 8,
	edgeOffset: 16,
	textBlur: 2,
	iconBlur: 3,
	stagger: 30,
	staggerLimit: 5,
	menuExit: 120,
	sheetExit: 400,
	successScale: .9,
	successRotation: 20,
	tickIn: 120,
	tickOut: 80,
	textCadence: 30,
	loadingDelay: 150,
	loadingMinimum: 400,
	spinnerPeriod: 600,
	progressPeriod: 1200,
	skeletonPeriod: 1500,
	thinkingPeriod: 2e3,
	sheetEasing: "cubic-bezier(0.32, 0.72, 0, 1)"
};
//#endregion
export { e as duration, t as easing, r as motionRecipe, n as spring };
